<div
  class="flex h-auto w-full flex-col rounded-xl bg-white p-[15px] text-[#0f2744] shadow-[0_2px_6px_rgba(0,0,0,0.1)]"
>
  <div class="flex min-h-[32px] justify-between">
    <h1
      class="m-0 text-wrap font-[Lato,Helvetica,Arial,sans-serif] text-base font-normal leading-5"
    >
      {{ data.title }}
    </h1>
  </div>
  <div
    class="relative flex h-full min-h-[80px] items-center justify-center rounded-lg pb-5 pt-5 text-center text-[40px] font-semibold text-[#0f2744]"
    [appTooltip]="tooltipTemplate"
    [attr.aria-busy]="loading"
    #modalContent
  >
    <span
      [ngClass]="ngClass"
      [class.opacity-20]="loading"
      [class.blur-sm]="loading"
    >
      {{ formatValue(data.value) }}
    </span>
    @if (loading) {
      <div class="absolute" role="status" [attr.aria-label]="'Loading ' + data.title">
        <mat-spinner [diameter]="75" aria-hidden="true"></mat-spinner>
      </div>
    }
  </div>

  @if (data.linkEnabled) {
    <div class="mt-[10px]">
      <a
        class="text-sm font-normal"
        [routerLink]="data.hyperlink || null"
        [queryParams]="data.linkParams"
        [ngClass]="{
          'cursor-default text-gray-600': !data.hyperlink,
        }"
      >
        {{ data.hyperlinkText || 'View ' + data.title }}
      </a>
    </div>
  }
</div>

<ng-template #tooltipTemplate>
  <div>
    <strong>{{ formatValue(data.value) }}</strong>
  </div>
</ng-template>
